export const restrictedUsers = [
  "cesc@cesc.com",
  "bescom@bescom.com",
  "gescom@gescom.com",
  "hescom@hescom.com",
  "mescom@mescom.com"
];
